import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignResponse } from '@/repositories/generated';

const response: CampaignResponse[] = [
  {
    id: '001',
    name: 'モックキャンペーン1',
  },
  {
    id: '002',
    name: 'モックキャンペーン2',
  },
  {
    id: '003',
    name: 'モックキャンペーン3',
  },
];

export const autocompleteCampaign = http.get(
  createMockEndpoint('/autocomplete/campaign'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
